import { gql } from '@apollo/client';

export const CREATE_FAVORITE_SHOP = gql`
  mutation createFavoriteShop($shopId: ID!) {
    createFavoriteShop(shopId: $shopId) {
      entity
      errors {
        message
        code
      }
    }
  }
`;
export const DESTROY_FAVORITE_SHOP = gql`
  mutation destroyFavoriteShop($shopId: ID!) {
    destroyFavoriteShop(shopId: $shopId) {
      entity
      errors {
        message
        code
      }
    }
  }
`;
